import RobotSelectPanel from './src/robot-select-panel';

export default RobotSelectPanel;
